import { useTranslation } from 'react-i18next';

export type SidebarNavToEntityNameMapKey = keyof ReturnType<
  typeof getSidebarNavToEntityName
>;

export const getSidebarNavToEntityName = (
  t: ReturnType<typeof useTranslation>['t'],
) => ({
  'sidebar-crm': t('client_one'),
  'sidebar-forms': 'Form',
  'sidebar-subscriptions': 'Subscription',
  'sidebar-invoices': 'Invoice',
  'sidebar-knowledgeBase': 'Article',
});

export const getShortcutActionIdsToMenuTitleMap = (
  t: ReturnType<typeof useTranslation>['t'],
) => ({
  'open-client': t('actions.open_client'),
  'create-entity-command': t('common.create'),
});

export type ShortcutActionIdsToMenuTitleMapType = ReturnType<
  typeof getShortcutActionIdsToMenuTitleMap
>;

export enum KeyboardKeys {
  Esc = 'Escape',
}
